"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpWidgetVXStatus = void 0;
const tmpls_1 = require("./tmpls");
const Web3Helper_1 = require("../libs/Web3Helper");
const BiMath_1 = require("../libs/BiMath");
const ERC20Contract_1 = require("../contracts/ERC20Contract");
class CmpWidgetVXStatus extends tmpls_1.CmpWidgetVXStatusBase {
    constructor() {
        super();
        this._vxBalance = BiMath_1.BiMath.Zero;
        this._vxInstWithdrawal = BiMath_1.BiMath.Zero;
        this.ctrls.lRate.text = '-';
        this.ctrls.lYourStakePLS.text = '-';
        this.ctrls.lTotalStakePLS.text = '-';
        this.disable();
    }
    get vxBalance() { return this._vxBalance; }
    get vxInstWithdrawal() { return this._vxInstWithdrawal; }
    refreshAsync(vxData, vx, vpool, vcontroller, walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const vxERC20 = new ERC20Contract_1.ERC20Contract(vx.address, vx.web3);
            const rate = BiMath_1.BiMath.ToBI(vxData.vxRatio);
            const instWithdrawal = BiMath_1.BiMath.ToBI(vxData.contedBalance);
            const totalSupply = yield vxERC20.totalSupply();
            const totalWithdrawal = yield vx.getTotalWithdrawalValueAsync();
            const validators = yield vcontroller.getValidatorsCountAsync();
            const validatorsExiting = yield vcontroller.getValidatorsToExitAsync();
            let totalStakePLS = "-";
            if (totalSupply) {
                const totalSupplyUPLSBI = BiMath_1.BiMath.ToBI(totalSupply);
                const totalStakePLSBI = totalSupplyUPLSBI * rate / BiMath_1.BiMath.Decimal;
                totalStakePLS = Web3Helper_1.Web3Helper.ToLargeNumberUnit(totalStakePLSBI, 5, "PLS");
            }
            let yourStakePLS;
            if (walletAddress) {
                const withdrawalVX = yield vx.getReserveOfAsync(walletAddress);
                const vxBalance = yield vxERC20.balanceOf(walletAddress);
                this._vxBalance = BiMath_1.BiMath.ToBI(vxBalance);
                const withdrawalVXBI = withdrawalVX ? BiMath_1.BiMath.ToBI(withdrawalVX.value) : BiMath_1.BiMath.Zero;
                const vxBalanceBI = vxBalance ? BiMath_1.BiMath.ToBI(vxBalance) : BiMath_1.BiMath.Zero;
                yourStakePLS = (vxBalanceBI + withdrawalVXBI) * rate / BiMath_1.BiMath.Decimal;
            }
            this._vxInstWithdrawal = instWithdrawal;
            this.enable();
            Web3Helper_1.Web3Helper.ShortLabel(this.ctrls.lRate, rate, 5, "PLS/uPLS");
            Web3Helper_1.Web3Helper.ShortLabel(this.ctrls.lInstWithdrawal, instWithdrawal, 3, "PLS");
            this.ctrls.lVXAddress.text = vx.address;
            this.ctrls.lVPoolAddress.text = vpool.address;
            this.ctrls.lValidators.text = validators !== undefined ? validators : "-";
            this.ctrls.lValidatorsExiting.text = validatorsExiting !== undefined ? validatorsExiting : "-";
            Web3Helper_1.Web3Helper.ShortLabel(this.ctrls.lTotalWithdrawal, totalWithdrawal ? BiMath_1.BiMath.ToBI(totalWithdrawal) : undefined, 3, "PLS");
            Web3Helper_1.Web3Helper.ShortLabel(this.ctrls.lTotalStakeUPLS, totalSupply ? BiMath_1.BiMath.ToBI(totalSupply) : undefined, 3, "uPLS");
            this.ctrls.lTotalStakePLS.text = totalStakePLS;
            this.ctrls.lYourStakePLS.text = Web3Helper_1.Web3Helper.ToLargeNumberUnit(yourStakePLS, 3, "PLS");
            this.ctrls.lYourStakeUPLS.text = Web3Helper_1.Web3Helper.ToLargeNumberUnit(this._vxBalance, 3, "PLS");
        });
    }
}
exports.CmpWidgetVXStatus = CmpWidgetVXStatus;
//# sourceMappingURL=CmpWidgetVXStatus.js.map